import React from 'react';

const NoAutorizado = () => {
  return (
    <div>
      <h1>No tienes acceso a esta página</h1>
      <p>Contacta con el administrador si crees que esto es un error.</p>
    </div>
  );
};

export default NoAutorizado;
 